import { ReactNode } from 'react'
import { RocketLaunch } from '@mui/icons-material'
import { AlertColor } from '@mui/material'

export interface BannerConfig {
  id: string
  message: ReactNode
  severity: AlertColor
  dismissible: boolean
  startDate?: Date | string
  endDate?: Date | string
  links?: Array<{
    text: string
    url: string
  }>
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  customIcon?: React.ComponentType<any>
}

export const generateHash = (str: string): string => {
  let hash = 0
  if (str.length === 0) return hash.toString()
  for (let i = 0; i < str.length; i++) {
    const char = str.charCodeAt(i)
    hash = (hash << 5) - hash + char
    hash = hash & hash
  }
  return 'banner_' + Math.abs(hash).toString(16)
}

export const BANNERS: BannerConfig[] = [
  {
    id: 'connected-communities',
    message:
      "Poli Community, meet Connected Communities. We're so excited to share this new feature that will transform your city/county partnership. Learn more here.",
    severity: 'info',
    dismissible: true,
    customIcon: RocketLaunch,
    links: [
      {
        text: 'Learn more here',
        url: 'https://www.polimorphic.com/blog-posts/introducing-connected-communities-a-smarter-way-for-cities-and-counties-to-serve-residents--together?utm_campaign=12666708-2025-05-02-Connected%20Communities%20Blog&utm_source=website&utm_medium=blog',
      },
    ],
    startDate: new Date(2025, 4, 2, 0, 0, 0),
    endDate: new Date(2025, 5, 2, 23, 59, 59),
  },
  {
    id: 'terms-of-service',
    message:
      "Our Terms of Service and Privacy Policy have been updated. We use tools like cookies, Hotjar, and Sentry to make your experience better by understanding how you use our site, analyze site use, and generate user and site analytics. By continuing, you're agreeing to our Terms of Service and Privacy Policy.",
    severity: 'info',
    dismissible: true,
    links: [
      {
        text: 'Terms of Service',
        url: 'https://www.polimorphic.com/terms-of-service',
      },
      {
        text: 'Privacy Policy',
        url: 'https://www.polimorphic.com/privacy-policy',
      },
    ],
  },
  // Example Banner:
  // {
  //   id: 'feature-announcement',
  //   message: "We've launched exciting new features! Check out our updated dashboard.",
  //   severity: 'success',
  //   dismissible: true,
  //   startDate: new Date(2025, 4, 5, 9, 0, 0), // May 5, 2025 at 9:00 AM
  //   endDate: new Date(2025, 4, 5, 17, 0, 0), // May 5, 2025 at 5:00 PM
  // },
]
